import { createRoute } from '@tanstack/react-router';
import { IconWorld } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { SOP } from './SOP';
import { Utility } from './Utility';

// Quản trị website (H-08) · Tiện ích (H-09a) · Quy trình & hướng dẫn (H-09b), cùng nhóm Nội bộ.
const kb: EzyModule = {
  nav: { key: 'webadmin', label: 'Quản trị', icon: IconWorld, section: 'Nội bộ', items: [{ key: 'utility', label: 'Tiện ích', to: '/ezy/utility' }, { key: 'sop', label: 'Quy trình', to: '/ezy/sop' }] },
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/utility', component: Utility }),
    createRoute({ getParentRoute: () => parent, path: '/sop', component: SOP }),
  ],
};
export default kb;
